module.exports = __webpack_public_path__ + "static/media/voucher_intregaion_image.b8966f7f.png";